import { ICellRendererParams } from "ag-grid-community";
import { useDialog } from "@/lib/Components/Dialog/Hooks/useDialog";
import { VehicleCreateDialog } from "@/app/Vehicles/Components/VehicleCreateDialog";
import { IconButton } from "@/lib/Components/Button/IconButton";
import { PlusIcon } from "@heroicons/react/24/outline";
import { useGqlQuery } from "@/lib/GraphQLCodegen/fetcher";
import { vehicleListQuery } from "@/app/Vehicles/GraphQL/vehicleListQuery";
import { cn } from "@/lib/utils";
import { getImportVehicleQueryVariables } from "@/app/Import/Utils/getImportTableQueryVariables";

export function VehicleRenderCell(props: ICellRendererParams<any>) {
  const cellValue = props.valueFormatted ? props.valueFormatted : props.value;
  const vehicleCode = cellValue;

  const supplier = props.colDef?.cellRendererParams?.supplier;
  const supplierId = supplier?.id;

  const { data } = useGqlQuery(
    vehicleListQuery,
    getImportVehicleQueryVariables(supplierId),
  );

  const vehicle = data?.vehicles.data.find((vehicle) => {
    if (!cellValue || typeof cellValue !== "string") return false;

    return vehicle.code === vehicleCode;
  });

  const { open } = useDialog(VehicleCreateDialog);

  const showWarning = !vehicle;

  if (!cellValue) return null;

  return (
    <div
      className={cn("flex w-full items-center space-x-2", {
        "bg-red-300 text-red-700": showWarning,
      })}
    >
      {showWarning ? (
        <IconButton
          type="button"
          onClick={() => {
            open({
              initialValues: {
                supplier: {
                  connect: supplierId,
                },
                code: cellValue,
              },
              initialSupplier: supplier,
            });
          }}
          Icon={PlusIcon}
          tooltip="Create vehicle"
        />
      ) : null}
      <span>{cellValue}</span>
    </div>
  );
}
